import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ITournament } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { TournamentsApiClient } from '../../apiClient/tournaments'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface ITournamentsAction extends IDefaultAction {
  payload?: ITournament[],
}

export interface ITournamentsState extends IDefaultState {
  payload?: ITournament[],
}

const initState: ITournamentsState = {}

export const tournamentsStateLoadFromApi = createAsyncThunk(
  'tournamentsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<ITournament>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<ITournament>> = await new TournamentsApiClient(axios).get({
      where: arg.where,
      nested: 'location',
      sort: { 'location.name': 1, name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const tournamentsSlice = createSlice({
  name: 'tournamentsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(tournamentsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(tournamentsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(tournamentsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const {clear: clearTournaments} = tournamentsSlice.actions
export default tournamentsSlice.reducer